import React, { ReactNode } from "react";
import { Control } from "react-hook-form";

import { ContractsFieldsTypes, ContractsFormValues } from "../types";
import DateField from "./date-field/DateField";
import DualStateSelectField from "./dual-state-select-field/DualStateSelectField";
import FileField from "./file-field/FileField";
import LongTextField from "./long-text-field/LongTextField";
import TermsDropdownField from "./terms-dropdown-field/TermsDropdownField";

type Props = {
  control: Control<ContractsFormValues>;
  fieldData: ContractsFieldsTypes;
  locked: boolean;
};

function ContractsDetailFieldRenderer({ control, fieldData, locked }: Props) {
  const fieldComponents: { [key: string]: ReactNode } = {
    renewal: (
      <DualStateSelectField
        width="100%"
        name="renewal"
        control={control}
        negativeText="Manual Renewal"
        positiveText="Automatic Renewal"
        locked={locked}
      />
    ),
    file: (
      <FileField
        width="100%"
        name="file"
        control={control}
        rules={{ required: true }}
        locked={locked}
      />
    ),
    start_date: (
      <DateField
        width="100%"
        name="start_date"
        control={control}
        rules={{ required: true }}
        locked={locked}
      />
    ),
    review_date: (
      <DateField
        width="100%"
        name="review_date"
        control={control}
        rules={{ required: true }}
        locked={locked}
      />
    ),
    end_date: (
      <DateField
        width="100%"
        name="end_date"
        control={control}
        rules={{ required: true }}
        locked={locked}
      />
    ),
    terms: <TermsDropdownField name="terms" control={control} />,
    notes: (
      <LongTextField
        width="100%"
        name="notes"
        control={control}
        hasDetailView
        locked={locked}
      />
    ),
  };

  const selectedComponent = fieldComponents[fieldData.field_name];

  return selectedComponent || null;
}

export default ContractsDetailFieldRenderer;
